import useCurrentLocation from "@thooks/useCurrentLocation"
import { useNewEditTemplateCollectionServices } from "./useNewEditTemplateCollectionServices"
import { useCallback } from "react"
import { useNewEditTemplateCollectionContext } from "../context/NewEditTemplateCollectionContext"
import { nullToEmptyStringHelper } from "../helpers/nullToEmptyStringHelper"
import { buildDebtors } from "../helpers/buildDebtorsHelper"
import { emptyChargeDetail } from "../constants/emptyChargeDetail"

export const useNewEditCollectionSave = () => {
    const { setLoadingTemplate, setChargeDetail, setChargeDebtorsData, setHasUnsavedChanges, setCleanTable, chargeDebtorsData, chargeDetail, cleanTable, loadingTemplate } = useNewEditTemplateCollectionContext()
    const { param } = useCurrentLocation()
    const {
        getChargeDebtorsService,
        getChargeDetailService,
        updateChargeService
    } = useNewEditTemplateCollectionServices()

    const handleSaveTemplate = async () => {

        const debtors = cleanTable ? { debtors: [] } : { ...buildDebtors(chargeDebtorsData.columns, chargeDebtorsData.dataSource) }
        const jsonData = {
            charge_id: param.templateId,
            name: chargeDetail.charge.name,
            late_fee: chargeDetail.late_fee.metadata ?? null,
            recurrence: chargeDetail.recurrence.metadata ?? null,
            ...debtors
        }
        await updateChargeService({ setLoading: setLoadingTemplate, jsonData })
        await getInitialData()
        setHasUnsavedChanges(false)
        setCleanTable(false)
    }

    const getInitialData = useCallback(async () => {
        const data = await getChargeDetailService({ setLoading: setLoadingTemplate, charge_id: param.templateId })
        if (!data.late_fee.metadata) {
            data.late_fee.metadata = emptyChargeDetail.data.late_fee.metadata
        }
        //Conversion explicita debido a que el campo enabled de la metadata de la mora se envia de esta forma al actualizar la plantilla
        //de cobro en lugar de late_fee_enabled, que es como viene en los detalles de la plantilla
        data.late_fee.metadata.enabled = data.late_fee.metadata.late_fee_enabled
        setChargeDetail(data)
        const debtorsData = await getChargeDebtorsService({ setLoading: setLoadingTemplate, charge_id: param.templateId })
        //Pasar los datos que vienen en null a un string vacio salvo place_name y debtor_name
        const dataSource = debtorsData.dataSource.map((item, index) => ({ ...nullToEmptyStringHelper(item), key: index }))
        debtorsData.dataSource = dataSource
        setChargeDebtorsData(debtorsData)
    }, [getChargeDebtorsService, getChargeDetailService, setChargeDetail, setChargeDebtorsData, setLoadingTemplate, param.templateId])

    return {
        handleSaveTemplate,
        getInitialData,
        loadingTemplate,
    }
}